module.exports = __webpack_public_path__ + "static/media/bbc_news_live_uk-politics-36570120_plot.a48b10f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_live_uk-politics-36570120_plot.png
// module id = 353
// module chunks = 0